import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import AiCopilotDrawer from './AiCopilotDrawer';
import { Toaster } from 'react-hot-toast';
import { useTheme } from '../context/ThemeContext';

export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [aiDrawerOpen, setAiDrawerOpen] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const { theme } = useTheme();

  return (
    <div className={`min-h-screen ${theme === 'dark' ? 'bg-slate-950 text-slate-100' : 'bg-slate-50 text-slate-900'} antialiased font-sans`}>
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />

      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileSidebarOpen}
        onMobileClose={() => setMobileSidebarOpen(false)}
      />

      <Header
        collapsed={collapsed}
        onToggleAiDrawer={() => setAiDrawerOpen(!aiDrawerOpen)}
        onMobileMenuToggle={() => setMobileSidebarOpen(true)}
      />

      {/* Main content area — responsive margins */}
      <main className={`transition-all duration-300 p-4 sm:p-6 min-h-[calc(100vh-4rem)] ${collapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
        <div className="max-w-7xl mx-auto space-y-6">
          <Outlet />
        </div>
      </main>

      <AiCopilotDrawer isOpen={aiDrawerOpen} onClose={() => setAiDrawerOpen(false)} />
    </div>
  );
}
